// extracted by mini-css-extract-plugin
export default {"wrapper":"LearnMoreButton_wrapper__dQMx7","btnText":"LearnMoreButton_btnText__4XyL1","arrowRight":"LearnMoreButton_arrowRight__sKUZH"};